module.exports = __webpack_public_path__ + "static/logo-2023-956721400e6cfefeaa86c0faf8755ee7.png";